import {React} from 'react'

import { Route, Routes } from 'react-router-dom'
import MallIndex from './market/MallIndex'
import Application from './application/Application'
import Home from './home/Home'

export default function Content() {
  return (
    <div style={{justifyContent:"left",margin:0,padding:0,display:"flex",alignItems:"flex-start",background:"#f7f7f7"}}>        
      <Routes>
        <Route path='/' Component={Home} />
        <Route path='/market' Component={MallIndex} />
        <Route path='/market/:appid' Component={MallIndex} />
        <Route path='/market/:appid/:orderby/:ordertype' Component={MallIndex} />
        <Route path="/application" Component={Application}/>
        <Route path="/application/:id" Component={Application}/>  
        <Route path='*' Component={Home}/>            
      </Routes>    
    </div>
  )
}
